import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

export interface EsocialRetornoResponse {
  [key: string]: unknown
}

export function useFetchIdPrevidenciario(idApuracao?: string) {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useQuery({
    queryKey: ['previdenciario-por-apuracao', idApuracao],
    queryFn: async (): Promise<EsocialRetornoResponse | null> => {
      if (!idApuracao) {
        throw new Error('ID apuração não informado')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      try {
        const response = await api.get<EsocialRetornoResponse>(`/previdenciario/apuracao/${idApuracao}`, {
          headers: { Authorization: `Bearer ${token}` }
        })

        if (!response.data) {
          throw new Error('Erro ao buscar previdenciário da apuração')
        }

        return response.data
      } catch (error) {
        if (error instanceof AxiosError && error.response?.status === 404) {
          return null
        }

        throw error
      }
    },
    enabled: Boolean(idApuracao && user && token)
  })
}
